import { CircularProgress, Grid, Typography } from '@mui/material';
import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import "./view.css"

interface ViewAdDetailsProps {
  adData: any;
}

const ViewAdDetails: React.FC<ViewAdDetailsProps> = ({ adData }) => {
  const { t } = useTranslation('translation');
  const [imageLoading, setImageLoading] = React.useState(false);

  const onLoad = () => {
    setImageLoading(false);
  };

  return (
    <Grid container>
      <Grid container spacing={3} className="row-spacing">
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("productTitle")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.productTitle}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("productPriceDescription")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.productPriceDescription}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="row-spacing">
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("adLocation")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.adLocation}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("lastUpdatedBy")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.lastUpdatedBy}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="row-spacing">
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("createdAt")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.createdAt}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-title">{t("updatedAt")}</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography className="field-value">{adData?.updatedAt}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} className="row-spacing" ml={0} mt={0}>
        <Grid className={adData?.imageUrl ? "my-2" : "grid grid-cols-2 gap-x-16 my-2"}>
          <Grid className='col-span-1 font-[600]'>{t('image')}</Grid>
          <Grid
            item
            xs={6}
            className={adData?.imageUrl ? 'h-[140px]' : ''}
          >
            {adData?.imageUrl ?
              <img
                src={adData?.imageUrl}
                onLoad={onLoad}
                height="600"
                width="400"
                className='w-auto h-full aspect-square object-cover rounded-[0%] mt-2'
              /> : (imageLoading ? "" : "-")
            }
          </Grid>
          <Grid>
            {imageLoading && (
              <CircularProgress
                color='inherit'
                size={14}
                thickness={6}
                style={{ marginLeft: "10%" }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ViewAdDetails;